import Vue from "vue";
import LinearScale from "linear-scale";
import Slick from "vue-slick";
import _ from "lodash";
import Photographer from "../../components/Photographer";
import AnimatedComponent from "../../components/Animated";

let els;

if ((els = document.querySelectorAll(".studios-map")).length > 0) {
  for (let i = 0; i < els.length; i++) {
    const el = els[i];

    new Vue({
      el: el,
      name: "StudiosMap",
      components: { Slick, Photographer, AnimatedComponent },
      data() {
        return {
          opened: false,
          openModal: false,
          cities: [],
          citiesSelect: [],
          currentCity: false,
          currentLocation: false,
          displayModal: "none",
          currentStudio: false,
          windowWidth: window.innerWidth,
          showSlick: true,
          convert_coords: window.ConvertCoords,
          slickOptions: {
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
          },
          markersSizes: {
            1: " opacity-100 w-9 ",
            2: " opacity-100 w-12 ",
            3: " opacity-100 w-16 ",
          },
          markersActiveSizes: {
            1: " opacity-100 w-16 ",
            2: " opacity-100 w-20 ",
            3: " opacity-100 w-24 ",
          },
        };
      },
      computed: {
        studiosList: function () {
          if (this.currentCity && this.currentLocation) {
            let listOfStudios = [];
            this.currentCity.studios.forEach((studio) => {
              studio.distance = this.getDistance(
                studio.coor[0],
                this.currentLocation
              );
              listOfStudios.push(studio);
            });

            listOfStudios.sort((a, b) => {
              return a.distance > b.distance ? 1 : -1;
            });
            if (this.$refs.slick) {
              this.$nextTick(function () {
                this.$refs.slick.reSlick();
              });
            }

            this.currentStudio = listOfStudios[0];
            return listOfStudios;
          } else {
            if (this.$refs.slick) {
              this.$nextTick(function () {
                this.$refs.slick.reSlick();
              });
            }

            this.currentStudio = this.currentCity.studios[0];
            return this.currentCity.studios;
          }
        },
      },
      methods: {
        getImage: window.getImage,
        saveData(mycity, mystudio) {
          localStorage.setItem("booking-selected-city", mycity.toLowerCase());
          localStorage.setItem("booking-selected-studio", mystudio);
          document.location.href =
            document.location.origin + "/reserver-ma-seance";
        },
        slickNext() {
          this.$refs.slick.next();
        },
        slickPrev() {
          this.$refs.slick.prev();
        },
        slickNextMobile() {
          this.$refs.slickMobile[0].next();
        },
        slickPrevMobile() {
          this.$refs.slickMobile[0].prev();
        },
        selectStudio(studio) {
          // this.showSlick = false;
          if (this.$refs.slick) {
            this.$nextTick(function () {
              this.$refs.slick.reSlick();
            });
          }

          // this.$nextTick(function () {
          //   this.$nextTick(function () {
          //     this.showSlick = true;
          //   });
          // });

          this.currentStudio = studio;
        },
        selectCity(city) {
          if (city !== false) {
            this.currentCity = city;
            if (
              (this.studiosList.length > 0 && this.windowWidth > 767) ||
              this.studiosList.length === 1
            ) {
              if (this.$refs.slick) {
                this.$nextTick(function () {
                  this.$refs.slick.reSlick();
                });
              }

              this.currentStudio = this.studiosList[0];
              this.selectStudio(this.studiosList[0]);
            }
            localStorage.setItem("city", this.currentCity.url);
            let currentUrl = document.location.href;
            let newURL = currentUrl.split("/");
            newURL[3] = "studios";
            newURL[4] = this.currentCity.slug;
            let redirectTo = newURL.join("/");
            document.location.href = redirectTo ;
          }
        },
        isCurrentStudio(studio) {
          return this.currentStudio && studio.id === this.currentStudio.id;
        },
        isCurrentCity(city) {
          return this.currentCity && city.id === this.currentCity.id;
        },
        getMarkerSize(size, active) {
          if (typeof active !== "undefined")
            return this.markersActiveSizes[size];
          else return this.markersSizes[size];
        },
        getMarkerStyle(coords) {
          const position = this.coordsToPost(coords);

          return {
            top: position.y + "%",
            left: position.x + "%",
          };
        },
        findNearest(coords) {
          let nearestCity;
          let newDistance;
          let nearestDistance = 1000000000;

          this.citiesSelect.forEach((city) => {
            if (
              typeof nearestDistance === "undefined" ||
              (newDistance = this.getDistance(city.coords, coords)) <
                nearestDistance
            ) {
              nearestDistance = newDistance;
              nearestCity = city;
            }
          });
          if (nearestCity) {
            this.selectCity(nearestCity);
          }
        },
        getDistance(coords1, coords2) {
          var point1 = new google.maps.LatLng(coords1.lat, coords1.lng);
          var point2 = new google.maps.LatLng(coords2.lat, coords2.lng);

          var distance = google.maps.geometry.spherical.computeDistanceBetween(
            point1,
            point2
          );
          return distance / 1000;
        },
        getDistance2(coords1, coords2) {
          const radLat1 = (Math.PI * coords1.lat) / 180;
          const radLat2 = (Math.PI * coords2.lat) / 180;
          const theta = coords1.lng - coords2.lng;
          const radTheta = (Math.PI * theta) / 180;

          let dist =
            Math.sin(radLat1) * Math.sin(radLat2) +
            Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radTheta);

          if (dist > 1) dist = 1;

          dist = Math.acos(dist);
          dist = (dist * 180) / Math.PI;
          dist = dist * 60 * 1.1515;

          return dist;
        },
        getClickPos(event) {
          const pos = {
            x: (event.offsetX / 568) * 100,
            y: (event.offsetY / 576) * 100,
          };
        },
        posToCoords(coords) {
          const ScalerLatY = LinearScale(
            [this.convert_coords.pos0.y, this.convert_coords.pos1.y],
            [
              this.latToY(this.convert_coords.pos0.lat),
              this.latToY(this.convert_coords.pos1.lat),
            ]
          );
          const ScalerLngX = LinearScale(
            [this.convert_coords.pos0.x, this.convert_coords.pos1.x],
            [this.convert_coords.pos0.lng, this.convert_coords.pos1.lng]
          );

          return {
            lat: this.yToLat(ScalerLatY(coords.y)),
            lng: ScalerLngX(coords.x),
          };
        },
        coordsToPost(LatLng) {
          const ScalerLngY = LinearScale(
            [
              this.latToY(this.convert_coords.pos0.lat),
              this.latToY(this.convert_coords.pos1.lat),
            ],
            [this.convert_coords.pos0.y, this.convert_coords.pos1.y]
          );
          const ScalerLatX = LinearScale(
            [this.convert_coords.pos0.lng, this.convert_coords.pos1.lng],
            [this.convert_coords.pos0.x, this.convert_coords.pos1.x]
          );

          return {
            y: ScalerLngY(this.latToY(LatLng.lat)),
            x: ScalerLatX(LatLng.lng),
          };
        },
        latToY(lat) {
          return this.rad2deg(Math.asinh(Math.tan(this.deg2rad(lat))));
        },
        yToLat(y) {
          return this.rad2deg(Math.atan(Math.sinh(this.deg2rad(y))));
        },
        deg2rad(degrees) {
          var pi = Math.PI;
          return degrees * (pi / (180 * 1.5));
        },
        rad2deg(radians) {
          var pi = Math.PI;
          return radians * ((180 * 1.5) / pi);
        },
        scrollToResult(city) {
          if (city != false) {
            const element = document.getElementById("search-result");
            if (typeof element !== null && element !== "undefined") {
              window.scrollTo({
                top: element.offsetTop - 180,
                left: 0,
                behavior: "smooth",
              });
            }
          }
        },
        reviews() {
          this.openModal = true;
          this.displayModal = "block";
        },
        closeModal() {
          this.openModal = false;
          this.displayModal = "none";
        },
      },
      created() {
        this.cities = window.passdata.citiesSelect;
        this.citiesSelect = window.passdata.citiesSelect;

        const success = (position) => {
          // this.currentLocation = {
          //     "lat": 48.8293647,
          //     "lng": 2.3638148
          // };

          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          if (window.passdata.city_slug == false) {
            this.findNearest(this.currentLocation);
          }

          // Do something with the position
        };

        const error = (err) => {
          console.log("Permission denied");
          this.currentLocation = false;
        };

        // This will open permission popup

        navigator.geolocation.getCurrentPosition(success, error);
      },
      mounted() {
        window.onresize = () => {
          this.windowWidth = window.innerWidth;
        };
      },
      beforeMount() {
        if (window.passdata.city_slug) {
          this.currentCity = _.find(
            this.cities,
            (city, index) => city.slug === window.passdata.city_slug
          );
          localStorage.setItem("city", this.currentCity.url);
          this.scrollToResult(this.currentCity);
        }
      },
      beforeUpdate() {
        if (this.$refs.slick) {
          this.$refs.slick.destroy();
        }
      },
      updated() {
        if (this.$refs.slick) {
          this.$nextTick(function () {
            this.$refs.slick.create(this.slickOptions);
          });
        }
      },
    });
  }
}
